import React from 'react'
import PropTypes from 'prop-types'
import {customIcon} from '../shared/styles'

const BotIcon = ({size}) => {
    const {container, content} = customIcon(size, '#6dadef')
    return (
        <div style={container}>
            <i data-testid="mi" className="material-icons" style={content}>
                android
            </i>
        </div>
    )
}

BotIcon.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']).isRequired
}
export default BotIcon
